module.exports = __webpack_public_path__ + "img/星链智能制造解决方案banner.9f7e0421.png";